import { Construction } from "lucide-react";
import { useSetPageHeader } from "@/lib/page-header";

export function Placeholder({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  useSetPageHeader({ title }, [title]);

  return (
    <div className="mx-auto w-full max-w-4xl">
      <div className="rounded-3xl border border-dashed border-zinc-200 bg-white p-12 text-center dark:border-border dark:bg-card">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary">
          <Construction className="h-6 w-6" />
        </div>
        <h1 className="mt-4 text-xl font-bold text-zinc-900 dark:text-foreground">
          {title}
        </h1>
        <p className="mt-2 text-sm text-zinc-500 dark:text-muted-foreground">
          {description ?? "Módulo em desenvolvimento. Em breve por aqui."}
        </p>
      </div>
    </div>
  );
}
